"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWNER = exports.INITIATOR = exports.AUDITOR = exports.APPROVER = exports.ADMIN = void 0;
/** @deprecated use enum instead */
exports.ADMIN = 'ADMIN';
exports.APPROVER = 'APPROVER';
exports.AUDITOR = 'AUDITOR';
exports.INITIATOR = 'INITIATOR';
exports.OWNER = 'OWNER';
var organizationRoles;
(function (organizationRoles) {
    organizationRoles["ADMIN"] = "ADMIN";
    organizationRoles["APPROVER"] = "APPROVER";
    organizationRoles["AUDITOR"] = "AUDITOR";
    organizationRoles["INITIATOR"] = "INITIATOR";
    organizationRoles["OWNER"] = "OWNER";
})(organizationRoles || (organizationRoles = {}));
exports.default = organizationRoles;
